import { koreanCalendarDate } from '@repo/api-contracts';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * 희망 납기일의 가장 이른 허용 날짜 — 한국(UTC+9) 달력 기준 내일(YYYY-MM-DD).
 * 서버 quote-policy 와 같은 `koreanCalendarDate` 를 써서 브라우저 시간대에 흔들리지 않는다(견적 설계 §5-4).
 */
export const earliestDesiredDate = (now: Date): string =>
  koreanCalendarDate(new Date(now.getTime() + DAY_MS));

/** YYYY-MM-DD 끼리는 사전순 비교가 날짜순 비교다. */
export const isDesiredDateAllowed = (date: string, now: Date): boolean =>
  date >= earliestDesiredDate(now);
